import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { AG_GRID_LOCALE_FR, AG_GRID_LOCALE_EN, AG_GRID_LOCALE_ES } from '@ag-grid-community/locale';
import { AgGridReact } from "ag-grid-react";
import { getPublicLeadColumnDefinition } from "shared/topchef.grid"
import { Lead, PublicLead } from "shared/topchef.types"
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

ModuleRegistry.registerModules([AllCommunityModule]);

export interface BriefsListProps {
    leads: Lead[] | PublicLead[],
    detailsRenderer: any,
    height: string,
    paginateResults: boolean
}

const BriefsList = (props: BriefsListProps) => {

  const { t, i18n } = useTranslation();
  const columnsDefinition = getPublicLeadColumnDefinition({detailsRenderer: props.detailsRenderer, t});
  
  const gridLocale = useMemo(() => {
    const language = i18n.language;
    if (language === 'es') return AG_GRID_LOCALE_ES;
    if (language === 'en') return AG_GRID_LOCALE_EN;
    return AG_GRID_LOCALE_FR;
  }, [i18n.language]);

  return (
    <div className="ag-theme-alpine" id="all_briefs" style={{ width: '100%', height: props.height }}>
      {props.leads.length > 0 && (
        <AgGridReact
          key={i18n.language}
          rowData={props.leads}
          columnDefs={columnsDefinition}
          overlayNoRowsTemplate={`<div>${t('grid.empty')}</div>`}
          overlayLoadingTemplate={`<span>${t('grid.loading')}</span>`}
          pagination={props.paginateResults}
          paginationPageSize={20}
          domLayout="normal"
          rowBuffer={10}
          defaultColDef={{
            flex: 1,
            resizable: true,
            autoHeight: true,
          }}
          localeText={gridLocale}
        />
      )}
    </div>
  );
  

  };

  export default BriefsList;
  
